<template>
  <div class="tw-document-list">
    <div class="row mb-2">
      <div class="col-12">
        <q-checkbox
            :label="$t('task.printDocument.templateList.selectAll')"
            outlined
            dense
            @click="onSelectAllChange"
            v-model="checkAllModel"
            class="bg-white"
        />
      </div>
    </div>
    <div class="row q-ml-md q-mt-md scrollable-content">
      <div
          class="col-12 p-2 mb-2 default-border-radius border"
          v-for="(template, index) in templates"
          :key="index"
      >
        <PrintDocumentListItem
            @child-boolean-changed="updateParentBoolean"
            :noticeTemplate="template"
            :index="index"
            :reference="reference"
        />
      </div>
    </div>
    <div class="row tw-document-actions">
      <div class="col-12">
        <PrintDocumentActions :reference="reference"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import store from "@/store";
import {NoticeTemplate, PackNoticeTemplateInfo} from "@/types";
import PrintDocumentListItem from "@/components/document/list/PrintDocumentListItem.vue";
import PrintDocumentActions from "@/components/document/list/PrintDocumentActions.vue";

@Options({
  props: ["reference"],
  components: {
    PrintDocumentActions,
    PrintDocumentListItem
  }
})
export default class PrintDocumentList extends Vue {
  reference: any;
  checkAllModel = false;

  get templates() {
    return store.state.printDocumentModule.templates;
  }

  onSelectAllChange() {
    store.dispatch("printDocumentModule/setAllTemplateSelected", {
      selected: this.checkAllModel,
    });
  }

  handleCheckboxes(item: NoticeTemplate, action: boolean) {
    const templates = store.state.printDocumentModule.templates;
    this.handleCheckboxWithAction(item, action, templates);
    let findItem: any = templates.find((el) => !el.selected);
    let findPackItem: any = templates
        .filter((el) => el.isPack)
        .map((el: NoticeTemplate) =>
            el.items?.find((el: PackNoticeTemplateInfo) => !el.selected)
        );
    if (findItem || findPackItem[0]) return true;
  }

  private handleCheckboxWithAction(
      item: NoticeTemplate,
      action: boolean,
      templates: NoticeTemplate[]
  ) {
    if (action) {
      item.selected = true;
      templates.forEach((el: NoticeTemplate) => {
        if (el.fileName !== item.fileName) {
          el.selected = false;
          if (el.items && el.items.length > 0) {
            el.items.forEach((packItem) => (packItem.selected = false));
          }
        } else if (
            item.isPack &&
            item.items?.filter((item) => item.selected).length === 0
        ) {
          el.items?.forEach((packItem) => (packItem.selected = true));
        }
      });
    }
  }

  updateParentBoolean(item: NoticeTemplate, action: boolean) {
    if (this.handleCheckboxes(item, action)) {
      this.checkAllModel = false;
    } else this.checkAllModel = true;
  }

  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }

  created() {
    if (!this.templates || !this.templates.length) {
      store.dispatch("printDocumentModule/getTemplates", {
        currentRoute: this.currentRoute
      });
    }
    store.dispatch("printDocumentModule/setAllTemplateSelected", {
      selected: false,
    });
  }

}
</script>

<style scoped>
.scrollable-content {
  max-height: 470px; 
  overflow-y: auto;
}
</style>
